import React, { useContext, useMemo, useState } from "react";
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonPage,
} from "@ionic/react";

import { useHistory } from "react-router-dom";
import { DataContext } from "../context/DataContext";
import Toolbar from "../components/Toolbar";

const ConfirmEmail: React.FC = () => {
  const history = useHistory();
  const VERIFY_EMAIL_STORAGE_KEY = "verifyEmailAddress";
  const { appUserData } = useContext(DataContext as any) as { appUserData?: any };
  const [verificationCode, setVerificationCode] = useState<string>("");

  const verifyEmailAddress = useMemo(() => {
    return String(
      appUserData?.campusmenu_user_login ??
      appUserData?.loginEmail ??
      appUserData?.email ??
      localStorage.getItem(VERIFY_EMAIL_STORAGE_KEY) ??
      ""
    ).trim();
  }, [appUserData]);

  const handleVerifyCode = () => {
    if (verificationCode.length !== 5) {
      alert("Bitte geben Sie einen 5-stelligen Code ein.");
      return;
    }

    if (verifyEmailAddress === "") {
      alert("Es konnte keine E-Mail-Adresse zur Verifizierung ermittelt werden.");
      return;
    }

    const formData = new FormData();
    formData.append("loginEmail", verifyEmailAddress);
    formData.append("code", verificationCode);
    formData.append("verificationCode", verificationCode);

    fetch(
      "https://login.saint-online.de/funktionen/api2/campusmenu/setMailVerify.php",
      { method: "POST", body: formData }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 200) {
          history.push("/confirm-phone-code");
        } else {
          alert(JSON.stringify(data));
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error?.msg ?? error));
      });
  };



  return (
    <IonPage>
      
      <IonContent fullscreen>
      <IonHeader>
      <Toolbar />
      </IonHeader>
        <IonCard>
          <IonCardHeader>
            <IonCardTitle>Bestätigen Sie Ihre E-Mail-Adresse</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <p>Zur Bestätigung Ihrer E-Mail-Adresse haben wir Ihnen eine Mail geschickt. Bitte geben Sie den enthaltenen Code ein.</p>
            <IonItem>
              <IonLabel position="floating">5-stelliger Code</IonLabel>
              <IonInput
                type="tel"
                inputmode="numeric"
                maxlength={5}
                value={verificationCode}
                onIonInput={(e: any) => {
                  const rawValue = e.detail.value ?? "";
                  const numericOnly = String(rawValue).replace(/\D/g, "").slice(0, 5);
                  setVerificationCode(numericOnly);
                }}
              ></IonInput>
            </IonItem>
            <IonButton expand="full" onClick={handleVerifyCode} disabled={verificationCode.length !== 5}>
              Code prüfen
            </IonButton>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  );
};

export default ConfirmEmail;
